import unescapedText from 'I18n/utils/unescapedText';
export const companyTechActionTextParser = action => {
  return unescapedText('copilotToolkit.streamingMessage.companyTech', {
    domain: action.domain,
    companyName: action.company_name
  });
};